import MoneyRendererV3 from '@components/Money/MoneyRendererV3/MoneyRendererV3';
import { MoneyRendererV3DirectionEnum } from '@components/Money/MoneyRendererV3/moneyRendererV3.types';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { ProductCardsPriceConfig } from '../../productCardsBlock.types';
import { useProductCardsPrice } from './useProductCardsPrice';

type ProductCardsRowPriceProps = Omit<ProductCardsPriceConfig, 'isVisible'>;

const ProductCardsRowPrice = ({
  prices,
  isRetailDisabled,
  isWholesaleDisabled,
}: ProductCardsRowPriceProps) => {
  const { translate } = useTranslation();
  const { hasPrices, wholesale } = useProductCardsPrice({
    prices,
    isRetailDisabled,
    isWholesaleDisabled,
  });

  if (!hasPrices) {
    return (
      <Typography variant="micro1" color="textSecondary" align="right">
        {translate(LangEnum.PRODUCT_DETAILS_UNAVAILABLE_GRID)}
      </Typography>
    );
  }

  if (!wholesale) {
    return null;
  }

  return (
    <MoneyRendererV3
      direction={MoneyRendererV3DirectionEnum.COLUMN}
      horizontalAlign="right"
      size="medium"
      value={wholesale.value}
      promotionValue={wholesale.promotionValue}
    />
  );
};

export default ProductCardsRowPrice;
